import { IonContent, IonPage, IonButton, IonInput } from "@ionic/react";
import { Icon, LockIcon, UserIcon } from "evergreen-ui";
import { useContext, useState } from "react";
import { globalContext } from "../../global/Store";
import { Lookup, User, Development } from "../../global/Types";
import {
  LogoGroup,
  LoginForm,
  Logo,
  UsernameGroupColumn,
  UsernameGroup,
  PasswordGroup,
  UsernameGroupColumnFiller,
  ButtonOverlay,
  BtnLoginText,
} from "./LoginStyle";
import LogRocket from 'logrocket';
LogRocket.init('h7uamz/encompass_track');

export const Login = () => {
  const { globalState, dispatch, globalFunctions } = useContext(globalContext);

  const [username, setUsername] = useState<string | null | undefined>("");
  const [password, setPassword] = useState<string | null | undefined>("");

  const login = () => {

    console.log(globalFunctions)
    LogRocket.identify(String(username))
    globalFunctions
      .CallPortalApi("Authentication/Login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: !!username ? username.toLowerCase() : "",
          password: password,
        }),
      })
      .then(function (userResponse: User) {
       console.log(userResponse.token)
       
        var csPromise = globalFunctions
          .CallPortalApi("Lookup/List", {
            method: "POST",
            headers: {
              "Content-Type":"application/json",
              "Authorization":`Bearer ${userResponse.token}`
            },
            body: JSON.stringify({
              id: 6,
            }),
          })
          .then(function (lookupResponse: Lookup[]) {
            console.log(lookupResponse)
            dispatch({
              type: "SET_CASE_STATUS",
              payload: lookupResponse,
            });
          });

        var psPromise = globalFunctions
          .CallPortalApi("Lookup/List", {
            method: "POST",
            headers: {
              "Content-Type":"application/json",
              "Authorization":`Bearer ${userResponse.token}`
            },
            body: JSON.stringify({
              id: 1,
            }),
          })
          .then(function (lookupResponse: Lookup[]) {
            dispatch({
              type: "SET_PURCHASE_STATUS",
              payload: lookupResponse,
            });
          });

          var msPromise = globalFunctions
          .CallPortalApi("Lookup/List", {
            method: "POST",
            headers: {
              "Content-Type":"application/json",
              "Authorization":`Bearer ${userResponse.token}`
            },
            body: JSON.stringify({
              id: 5,
            }),
          })
          .then(function (lookupResponse: Lookup[]) {
            dispatch({
              type: "SET_MILESTONE_TYPES",
              payload: lookupResponse,
            });
          });

        var dvPromise = globalFunctions
          .CallPortalApi("Development/List", {
            method: "POST",
            headers: {
              "Content-Type":"application/json",
              "Authorization":`Bearer ${userResponse.token}`
            }
          })
          .then(function (developmentResponse: Development[]) {
            dispatch({
              type: "SET_DEVELOPMENTS",
              payload: developmentResponse,
            });
          });
        // [csPromise, msPromise, psPromise, dvPromise]
        Promise.all([csPromise, msPromise, psPromise, dvPromise])
          .then((values) => {
            dispatch({
              type: "SET_USER",
              payload: userResponse,
            });

            globalFunctions.Reroute("/home");
          })
          .catch((reason) => {
            console.error(reason);
          });
      });
  };

  const handleKeyDown = (e: any) => {
    if (e.key === 'Enter') {
      login();
    }
  }

  return (
    <IonPage>
      <IonContent style={{ "--background": "white" }}>
        <LogoGroup style={{ marginTop: "120px", width: "100%" }}>
          <Logo src={"../../assets/encompassicon/Encompass.png"}></Logo>
        </LogoGroup>
        <LoginForm>
          <UsernameGroupColumn>
            <UsernameGroup>
              <Icon
                icon={UserIcon}
                size={20}
                style={{
                  color: "white",
                  marginTop: "18px",
                  marginLeft: "10px",
                }}
              />
              <IonInput
                type="text"
                className="login-input"
                placeholder="Username"
                style={{
                  color: "#ff0000",
                  marginLeft: "10px",
                  boxShadow: "none",
                }}
                value={username}
                onIonChange={(event) => setUsername(event.detail.value)}
                onKeyDown={handleKeyDown}
              //   autocomplete="off"
              //   onfocusout="this.removeAttribute('readonly');"
              //   onfocus="this.setAttribute('readonly','readonly');"
              ></IonInput>
            </UsernameGroup>
            <PasswordGroup>
              <Icon
                icon={LockIcon}
                size={20}
                style={{
                  color: "white",
                  marginTop: "18px",
                  marginLeft: "10px",
                }}
              />
              <IonInput
                type="text"
                className="login-input"
                placeholder="Password"
                style={{
                  color: "#980053",
                  marginLeft: "10px",
                  textSecurity: " disc",
                  WebkitTextSecurity: "disc",
                  boxShadow: "none",
                }}
                value={password}
                onIonChange={(event) => setPassword(event.detail.value)}
                onKeyDown={handleKeyDown}
              //   autocomplete="off" //readonly
              //   onfocusout="this.removeAttribute('readonly');"
              //   onfocus="this.setAttribute('readonly','readonly');"
              ></IonInput>
            </PasswordGroup>
          </UsernameGroupColumn>
          <UsernameGroupColumnFiller></UsernameGroupColumnFiller>
          <IonButton className="jm-ion-btn" onClick={login}>
            <ButtonOverlay>
              <BtnLoginText>Login</BtnLoginText>
            </ButtonOverlay>
          </IonButton>
          <UsernameGroupColumnFiller>
            <div style={{textAlign: "center"}}><a href="/forgot-password">Forgot Password</a></div>
          </UsernameGroupColumnFiller>
        </LoginForm>
      </IonContent>
    </IonPage>
  );
};
